import React from 'react';
import * as Render from '../../platformui/Base/Render';
import classNames from 'classnames';

const Heading = (props) => {
  const HeadingContent = Render.Property(
    props.Heading,
    props.PropertyName ? props.PropertyName : 'HeadingContent'
  );

  const headingClasses = classNames({
    'anchor-nav-multi-item': props.isAnchorMultiNav && props.HeadingLevel !== 1,
    [props.className]: props.className,
  });

  if (props.HeadingLevel > 6)
    return <h6 className={headingClasses}>{HeadingContent}</h6>;

  switch (props.HeadingLevel) {
    case 1:
      return <h1 className={headingClasses}>{HeadingContent}</h1>;
    case 2:
      return (
        <h2 id={props.id} className={headingClasses}>
          {HeadingContent}
        </h2>
      );
    case 3:
      return (
        <h3 id={props.id} className={headingClasses}>
          {HeadingContent}
        </h3>
      );
    case 4:
      return (
        <h4 id={props.id} className={headingClasses}>
          {HeadingContent}
        </h4>
      );
    case 5:
      return <h5 className={headingClasses}>{HeadingContent}</h5>;
    case 6:
      return <h6 className={headingClasses}>{HeadingContent}</h6>;
    default:
      return <h1 className={headingClasses}>{HeadingContent}</h1>;
  }
};

export default Heading;